import type { Edge, Node, Viewport } from '@xyflow/react';

export type EditorNodeData = Record<string, unknown> & {
  label?: string;
  name?: string;
  description?: string;
  category?: string;
  icon?: string;
  colorOverride?: string;
  url?: string;
  responsible?: string;
  notes?: string;
  status?: string;
  attachments?: unknown[];
};
export type EditorNode = Node<EditorNodeData> & { locked: boolean };
export type EditorEdge = Edge<Record<string, unknown>>;

export interface EditorGraph {
  schemaVersion: number;
  nodes: EditorNode[];
  edges: EditorEdge[];
  viewport: Viewport;
  [key: string]: unknown;
}

export const GRID_SIZE = 16;
export const HISTORY_LIMIT = 50;
export const PASTE_OFFSET = 32;

export function cloneGraph(graph: EditorGraph): EditorGraph {
  return structuredClone(graph);
}

export function graphContentEquals(left: EditorGraph, right: EditorGraph): boolean {
  return JSON.stringify(left) === JSON.stringify(right);
}
